import { atom } from "recoil";
import { CalendarViewType } from "../../constants";
import { localStorageEffect } from "../localStorage/localStorageEffect";

export const calendarEventState = atom({
  key: "calendarEventState",
  default: [],
});

// TODO 이미 가져온 캘린더 데이터 전체를 캐싱하는 방식으로 변경

// NOTE Integration 관련 코드
export const dragEventState = atom({
  key: "dragEventState",
  default: null,
});

export const calendarViewState = atom({
  key: "calendarViewState",
  default: CalendarViewType.WEEK.type,
  effects: [localStorageEffect("calendarViewType", CalendarViewType.WEEK.type)],
});

export const showMorePopupState = atom({
  key: "showMorePopupState",
  default: false,
});
